import angular from 'angular'
import templateUrl from './schedule-event-office-assignment-editor.component.html'
import { sortIcdOfficeByOwner } from '../../../core/services/data-services/icd-office.service'

export const ScheduleEventOfficeAssignmentEditorComponent = {
    templateUrl,
    controller: ScheduleEventOfficeAssignmentEditorController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


export const ScheduleEventOfficeAssignmentEditorModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexScheduleEventOfficeAssignmentEditor",
    controller: 'ScheduleEventOfficeAssignmentEditorController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

function ScheduleEventOfficeAssignmentEditorController($uibModal, $q, utilityService,
    icdOfficeService, scheduleEventService) {
    'ngInject'

    const vm = this;
    vm.$onInit = onInit;
    vm.loaded = false;
    vm.icdOffices = [];
    vm.scheduleEvent;
    vm.handleSave = handleSave;
    vm.handleCancel = handleCancel;
    vm.pristineSelectedOffices = [];
    function onInit() {

        utilityService.showLoading();
        vm.divisionID = vm.resolve.divisionID;
        vm.scheduleEvent = vm.resolve.scheduleEvent;
        loadIcdOffices()
            .then(function (offices) {
                vm.scheduleEvent.SelectedOffices = [];
                vm.scheduleEvent.ScheduleEventOffices.forEach(function (office) {
                    const officeObj = offices.filter(function (off) {
                        return office.IcdOfficeID === off.Id
                    })[0];
                    hydrateIcdOffice(officeObj);
                    vm.scheduleEvent.SelectedOffices.push(officeObj);
                });
                vm.pristineSelectedOffices = angular.copy(vm.scheduleEvent.SelectedOffices);
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function loadIcdOffices() {
        if (vm.divisionID) {
            return icdOfficeService.retrieveIcdOffices({
                DivisionID: vm.divisionID
            }).then(function (offices) {
                vm.icdOffices = offices.sort(sortIcdOfficeByOwner);
                vm.icdOffices.forEach(hydrateIcdOffice);
                vm.pristineIcdOffices = angular.copy(vm.icdOffices);
                return vm.icdOffices;
            });
        }
    }

    function hydrateIcdOffice(office) {
        office.Name = office.OwnerName + " - " + office.IcdCorporationName;
    }

    function handleSave() {
        utilityService.showLoading();
        const unassignedOffices = vm.scheduleEvent.SelectedOffices.length === 0 ? vm.pristineSelectedOffices :
            vm.pristineSelectedOffices.filter(function (owner) {
                const unassignOffice = vm.scheduleEvent.SelectedOffices.filter(function (assignedOffice) {
                    return owner.Id === assignedOffice.Id
                });
                return !(unassignOffice.length > 0);
            });

        if (unassignedOffices.length > 0) {
            const offices = unassignedOffices.map(function (office) {
                return office.IcdCorporationName;
            }).join(',')
            if (!confirm(`${offices} will be unassigned from the schedule and all of "
                + "their reps will be unassigned. Are you sure?`)) {
                utilityService.hideLoading();
                return;
            }
        }

        const request = {
            AssignIcdOffice: {
                AssignedIcdOfficeIDs: vm.scheduleEvent.SelectedOffices.map(function (office) {
                    return office.Id;
                }),
                UnassignedIcdOfficeIDs: unassignedOffices.map(function (office) {
                    return office.Id;
                })
            }
        };
        scheduleEventService.patchScheduleEvent(vm.scheduleEvent.ScheduleEventID, request)
            .then(function () {
                utilityService.hideLoading();
                vm.close({ $value: vm.scheduleEvent });
            }).catch(function (ex) {
                console.error(ex);
                alert("Assignment failed " + utilityService.getExceptionMessage(ex));
            })
    }

    function handleCancel() {
        vm.dismiss({ $value: 'cancel' });
    }
}
